import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateTimeFormat } from '../../../../util/GlobalConstant';

const DateRenderer = ({ itemValue }) => (
  <>
    {moment
      .utc(itemValue, [dateTimeFormat])
      .local()
      .format('DD/MM/YYYY')}
  </>
);

DateRenderer.propTypes = {
  itemValue: PropTypes.string.isRequired,
};

export default DateRenderer;
